<div class="container">
    <div class="row crud-header">
        <div class="col flex-shrink-0 text-nowrap d-flex align-items-center gap-3">
            <div routerLink="/{{Routenames.Projects}}/{{Routenames.Map}}"
                 class="controls-left-button"
                 matTooltip="Terug naar projectenkaart"
                 matTooltipPosition="after">
                <i class="fa fa-arrow-left-from-arc"></i>
            </div>
            <h1 class="mt-2">Gebruikers</h1>
        </div>
        <div class="col d-flex justify-content-center align-items-center flex-row gap-2">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Zoeken</mat-label>
                <input #searchInput matInput type="text"/>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Filter op rollen</mat-label>
                <mat-select [formControl]="roleFilterControl" multiple>
                    <mat-option *ngFor="let role of availableRoles" [value]="role.key">
                        {{role.name}}
                    </mat-option>
                    <mat-option [value]="withoutRolesKey">Geen rollen</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-auto">
            <mat-paginator [pageSizeOptions]="[10, 20, 100]"></mat-paginator>
        </div>
    </div>
    <table [dataSource]="dataSource" class="mat-elevation-z8 w-100 mb-4" mat-table matSort matSortActive="created_at" matSortDirection="desc">
        <ng-container matColumnDef="created_at">
            <th *matHeaderCellDef mat-header-cell mat-sort-header width="200">Aangemaakt</th>
            <td *matCellDef="let user" class="text-right pr-3" mat-cell> {{user.created_at | date: 'EEE d MMM yyyy HH:mm'}}</td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Naam</th>
            <td *matCellDef="let user" mat-cell> {{user.name}}</td>
        </ng-container>
        <ng-container matColumnDef="email">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>E-mailadres</th>
            <td *matCellDef="let user" mat-cell> {{user.email}}</td>
        </ng-container>
        <!-- Delete Column -->
        <ng-container matColumnDef="editUser">
            <th *matHeaderCellDef mat-header-cell width="70"></th>
            <td *matCellDef="let user" class="text-right" mat-cell>
                <button color="primary" mat-flat-button routerLink="/{{Routenames.Users}}/{{user.id}}">
                    <i class="fa fa-pencil"></i>
                </button>
            </td>
        </ng-container>
        <ng-container matColumnDef="deleteUser">
            <th *matHeaderCellDef mat-header-cell width="70"></th>
            <td *matCellDef="let user" class="text-right" mat-cell>
                <button (click)="delete(user)" color="primary" mat-flat-button>
                    <i class="fa fa-trash"></i>
                </button>
            </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>
</div>
